import LegalShell from "../components/LegalShell";

export default function Impressum() {
  return (
    <LegalShell title="Impressum">
      <h2>Angaben gemäß § 5 DDG</h2>
      <p>
        Check&#39;in Tarife GbR<br />
        An der Alten Ziegelei 5<br />
        48157 Münster<br />
        Deutschland
      </p>

      <h2>Vertreten durch</h2>
      <p>
        Die vertretungsberechtigten Gesellschafter:<br />
        Anil Dogan<br />
        Hisen Kajtazi
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: <a href="tel:+491772356898" data-testid="imprint-phone">+49 177 2356898</a><br />
        E-Mail: <a href="mailto:info@checkin-tarife.de" data-testid="imprint-email">info@checkin-tarife.de</a>
      </p>

      <h2>Verbraucherstreitbeilegung</h2>
      <p>
        Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </LegalShell>
  );
}
